import * as React from "react";
import { NavLink } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import CoreComponent from "../pages/CoreComponent";
import { t } from "i18next";
import { IHolder, ICountry, ITransaction } from "../interfaces";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { arrayToFormData } from '../utils/functions';
import { toast } from "react-toastify";
import Select2 from "./Select2";

interface IProps extends WithTranslation {
    isOpen: boolean,
    handleModal: any,
    user_id?: number,
    transaction?: ITransaction
}

interface IState {
    isLoading: boolean,
    holders: { full_name: string, user_id: number }[],
}

class TransactionModal extends CoreComponent<IProps, IState> {
    state: IState = {
        holders: [],
        isLoading: false
    }

    async componentWillMount() {
        let response: AxiosResponse = await Axios.get(`${config.api}/user/list`);

        if (!this.isUnmounted) {
            this.setState({
                holders: response.data
            });
        }
    }

    async handleSubmit(data: any, setErrors: any) {
        let { t } = this.props;

        let formData = arrayToFormData(data);

        if (!this.isUnmounted) {
            this.setState({
                isLoading: true,
            }, async () => {
                let response: any;

                response = await Axios.post(`${config.api}/transactions/create`, formData);

                if (response.data.status == "error") {
                    let errors: any = {};

                    for (let prop in response.data.errors) {
                        errors[prop] = response.data.errors[prop].join(", ");
                        toast(response.data.errors[prop].join(", "), { type: "error" });
                    }

                    if (!this.isUnmounted) {
                        this.setState({
                            isLoading: false
                        });
                    }

                    setErrors(
                        errors
                    );
                } else {
                    if (!this.isUnmounted) {
                        toast(t("Транзакция сохранена."), { type: "success" });
                        this.setState({
                            isLoading: false
                        });

                        this.props.handleModal();
                    }
                }
            });
        }
    }

    render() {
        let initialValues: any = this.props.transaction ? {
            ...this.props.transaction,
            payment_date: this.props.transaction.payment_date.split(" ")[0],
            payment_time: this.props.transaction.payment_date.split(" ")[1].substring(0, 5),
            upload_id: this.props.transaction.upload_id || "",
            uz_transactions_id: this.props.transaction.uz_transactions_id || "",
        } : {
            code: "",
            name: "",
            payment_date: "",
            payment_time: "",
            currency: "",
            type: 2,
            status: "2",
            place: "",
            comment: "",
            user_id: this.props.user_id || "",
            id: ""
        }

        let { t } = this.props;

        return (
            <div className={"popup " + (this.props.isOpen ? "d-flex" : "")}>
                <div className="popup__content" style={{ height: "439px" }}>
                    <img onClick={() => this.props.handleModal()} src="img/Icon ionic-md-add.png" alt="" className="popup-del" />
                    <h1 className="popup__title">{this.props.transaction ? "Изменение транзакции" : "Добавление оплаты вручную"}</h1>
                    <Formik
                        enableReinitialize={true}

                        initialValues={initialValues}
                        onSubmit={async (values, { setErrors }) => {
                            await this.handleSubmit(values, setErrors);
                        }}

                        validationSchema={Yup.object().shape({
                            code: Yup.string(),
                            name: Yup.string(),
                            payment_date: Yup.string().required(),
                            currency: Yup.number().required(),
                            id: Yup.number(),
                            user_id: Yup.number().required(),
                            type: Yup.number().required(),
                            status: Yup.number().required(),
                            comment: Yup.string(),
                            place: Yup.string(),
                        })}
                    >
                        {(props) => {
                            const {
                                values,
                                errors,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                touched,
                                setFieldValue,
                                setFieldTouched
                            } = props;

                            return (
                                <form id="official-signup" onSubmit={handleSubmit}>
                                    <div className="popup__items">
                                        <div className="popup__item">
                                            <span>Правообладатель:</span>
                                            <div style={{ marginLeft: "25px", marginBottom: "5px" }} >
                                                <Select2
                                                    options={this.state.holders}
                                                    name="user_id" 
                                                    value={values.user_id} onChange={handleChange} onBlur={handleBlur} 
                                                    className={(touched.user_id && errors.user_id ? "required popup-select" : " popup-select")}
                                                />
                                                {/* <select name="user_id" value={values.user_id} onChange={handleChange} onBlur={handleBlur} className={(touched.user_id && errors.user_id ? "required popup-select" : " popup-select")}>
                                                    <option value="">Выберите правообладателя...</option>
                                                    {this.state.holders.map((holder: { full_name: string, user_id: number }, i: number) => {
                                                        return (
                                                            <option value={holder.user_id} key={i}>{holder.full_name}</option>
                                                        );
                                                    })}
                                                </select> */}
                                            </div>
                                            <span>Дата:</span>
                                            <div className="input-group mb-3">
                                                <input style={{ border: "1px solid #232636", marginLeft: "25px", width: "140px" }} type="date" name="payment_date" value={values.payment_date} onChange={handleChange} onBlur={handleBlur} className={(touched.payment_date && errors.payment_date ? "required form-control" : " form-control")} />
                                            </div>
                                            <span>Время:</span>
                                            <div className="input-group mb-3">
                                                <input style={{ border: "1px solid #232636", marginLeft: "25px", width: "140px" }} type="time" name="payment_time" value={values.payment_time} onChange={handleChange} onBlur={handleBlur} className={(touched.payment_time && errors.payment_time ? "required form-control" : " form-control")} />
                                            </div>
                                            <span>Сумма:</span>
                                            <div className="form-sum mb-3" style={{ marginLeft: "25px" }}>
                                                <input type="text" placeholder="$" name="currency" value={values.currency} onChange={handleChange} onBlur={handleBlur} className={(touched.currency && errors.currency ? "required" : "")} />
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex" }}>
                                                        <input type="radio" value="2" checked={values.type == 2} name="type" onChange={handleChange} onBlur={handleBlur} />
                                                        <span style={{ marginBottom: "10px" }}>Вывод</span>
                                                    </div>
                                                    <div style={{ display: "flex" }}>
                                                        <input type="radio" value="1" checked={values.type == 1} name="type" onChange={handleChange} onBlur={handleBlur} />
                                                        <span style={{ marginBottom: "0" }}>Доп. доход</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="popup__item">
                                            {values.type == 2 && <> <span>Код транзакции:</span>
                                                <div style={{ marginLeft: "25px", marginBottom: "25px" }}>
                                                    <input type="text" placeholder="Напишите код" name="code" value={values.code} onChange={handleChange} onBlur={handleBlur} className={(touched.code && errors.code ? "required" : "")} />
                                                </div>
                                            </>}
                                            {values.type == 1 && <>
                                                <span>Площадка:</span>
                                                <div style={{ marginLeft: "25px", marginBottom: "25px" }}>
                                                    <input
                                                        type="text"
                                                        autoComplete="off"
                                                        list="sources"
                                                        placeholder="Выберите площадку"
                                                        name="place" value={values.place} onChange={handleChange} onBlur={handleBlur} className={(touched.place && errors.place ? "required" : "")}
                                                    />
                                                </div>
                                                <datalist id="sources">
                                                    <option>YouTube</option>
                                                    <option>YouTube Music</option>
                                                    <option>RizaNova Music</option>
                                                </datalist>
                                            </>}
                                            {values.type == 2 && <> <span>Способ оплаты:</span>
                                                <div style={{ marginLeft: "25px", marginBottom: "25px" }}>
                                                    <input type="text" placeholder="Напишите способ оплаты" name="name" value={values.name} onChange={handleChange} onBlur={handleBlur} className={(touched.name && errors.name ? "required" : "")} />
                                                </div>
                                            </>}
                                            {/* <span>Статус:</span>
                                            <div style={{ marginLeft: "25px", marginBottom: "25px" }}>
                                                <select name="status" value={values.status} onChange={handleChange} onBlur={handleBlur} className={(touched.status && errors.status ? "required popup-select" : "popup-select")} >
                                                    <option value="">Выберите статус...</option>
                                                    <option value="1">Ожидает</option>
                                                    <option value="2">Оплачен</option>
                                                    <option value="3">Отказан</option>
                                                </select>
                                            </div> */}
                                            <input type="hidden" name="status" value={values.status} onChange={handleChange} onBlur={handleBlur} />
                                            <span>Комментарий:</span>
                                            <div style={{ marginLeft: "25px" }}>
                                                <textarea placeholder="Напишите комментарий..." name="comment" value={values.comment} onChange={handleChange} onBlur={handleBlur} className={(touched.comment && errors.comment ? "required" : "")}></textarea>
                                                <button className="crm-button popup-send">
                                                    {this.props.transaction ? "Измененить" : "Добавить"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>

                </div>
            </div>
        );
    }
}

export default withTranslation()(TransactionModal);